import React, { Component } from 'react';
import { dashboardActions, userActions, alertActions } from '../../_actions';
import { connect } from 'react-redux';
import "jspdf-autotable";
import { MdOutlineAddCircleOutline } from "react-icons/md";
import { BsArrowUpCircle, BsArrowDownCircle } from "react-icons/bs";
import { confirmAlert } from 'react-confirm-alert';
import TetherModal from './components/TetherModal/TetherModal';
import ReceiveModal from './components/ReceiveModal/ReceiveModal';


class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      pageNo: 1,
      size: 10,
      fieldslogin: {},
      errorslogin: {},
      option: {},
      showLeaderSection: false,
      activeTab: 1,
      isPackageListOpen: true,
      isHistoryOpen: false,
      isBioPreservation: false,
      isCertificates: false,
      isHovered: false,
      isNetwork: false,
      isTether: false,
      fieldTicketId: false,
      transactionModal: false,
      openText: false,
      clickedOutside: 0,
      clickedOutBanking: false,
      isPayment: false,
      isReceive: false,
      addressName: '',
      toAddress: '',
      amount: '',
      coin: { symbol: 'GCN' }, // Replace with your initial coin state
      loader: false,
      coinSelect: '',
      cAddress: '',
      amount1: '',
      walletName: ''
    }
  }

  componentDidMount() {
    let addresss = this.props.match && this.props.match.params && this.props.match.params.address ? this.props.match.params.address : null;
    let tempsData = {
      address: addresss
    }

    this.props.dispatch(userActions.getAddressList())
    this.props.dispatch(userActions.getWalletList(tempsData))
    this.props.dispatch(userActions.getUserWalletToBuy(tempsData))
    window.scrollTo(0, 0)
  }

  static getDerivedStateFromProps(nextProps) {

    if (nextProps.users.sendCoinSuccess) {
      return {
        ...nextProps,
        fieldslogin: {},
        errorslogin: {}
      }
    } else {
      return {
        ...nextProps
      }
    }
  }

  onClickMenu = (url) => {
    this.props.history.push(url)
  }

  handleBuyPackage = (data) => {
    let datatemp = {
      packageId: data.id,
      amount: data.price
    }
    confirmAlert({
      title: 'Confirm to buy package?',
      p: `Are you sure to spend ${data.price} $?`,
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.dispatch(dashboardActions.buyPackage(datatemp))
            // this.props.dispatch(userActions.getProfileDataPi())
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });
  };

  handleOpenPackageList = () => {
    this.setState({ isPackageListOpen: true });
  };

  handleClosePackageList = () => {
    this.setState({ isPackageListOpen: false });
  };

  handleOpenNetwork = (ele) => {
    console.log('ele______________________________', ele);
    const { users } = this.props;
    let { getAddressList } = users;
    const add = this.props.match && this.props.match.params && this.props.match.params.address ? this.props.match.params.address : getAddressList && getAddressList[0] && getAddressList[0].address ? getAddressList[0].address : ''
    const contractAddr = ele && ele.cAddress ? ele.cAddress : null
    this.props.history.push('/app/Send' + "/" + add + "/" + contractAddr)

    this.props.dispatch(userActions.savedname(ele))


  };

  handleCloseNetwork = () => {
    this.setState({ isNetwork: false });
  };

  handleOpenTether = () => {
    this.setState({ isTether: true })
  };

  handleCloseTether = () => {
    this.setState({ isTether: false })
  }

  handleOpenPayment = () => {
    const { users } = this.props;
    let { getAddressList } = users;
    const add = this.props.match && this.props.match.params && this.props.match.params.address ? this.props.match.params.address : getAddressList && getAddressList[0] && getAddressList[0].address ? getAddressList[0].address : ''
    this.props.history.push('/app/Payment' + "/" + add)

  };

  handleClosePayment = () => {
    this.setState({ isPayment: false })
  }
  handlePrimaryWalletOpen = () => {
    this.setState({ fieldTicketId: true })
  }
  handlePrimaryWalletClose = () => {
    this.setState({ fieldTicketId: false })
  }

  handleTransactionOpen = () => {

    const { cAddress } = this.state;
    const { users } = this.props;
    let { getAddressList } = users;
    const add = this.props.match && this.props.match.params && this.props.match.params.address ? this.props.match.params.address : getAddressList && getAddressList[0] && getAddressList[0].address ? getAddressList[0].address : ''
    this.props.history.push("/app/AddContract" + '/' + add)
  }

  handleTransactionClose = () => {
    this.setState({ transactionModal: false })
  }
  handleRes = () => {
    this.setState({ openText: !this.state.openText })
  }
  handleResOutBanking = () => {
    this.setState({ clickedOutBanking: !this.state.clickedOutBanking })
  }

  handleResOut = (data) => {
    console.log('data_____________________', data);
    this.setState({ clickedOutside: data })
  }

  handleOpenReceive = () => {
    this.setState({ isReceive: true })
  };

  handleCloseReceive = () => {
    this.setState({ isReceive: false })
  }

  onCreateWallet = () => {
    if (!this.state.addressName) {
      alertActions.error('Wallet name is required');
      return;
    }
    let data = {
      walletName: this.state.addressName
    }

    this.props.dispatch(userActions.createWallet(data))

  }

  Saveaddresss = (temp) => {

    this.setState({ walletName: temp && temp.walletName })
    this.handlePrimaryWalletClose()
    const { users } = this.props;
    let { getAddressList } = users;
    let addresss = this.props.match && this.props.match.params && this.props.match.params.address ? this.props.match.params.address : getAddressList && getAddressList[0] && getAddressList[0].address ? getAddressList[0].address : ''

    let tempsData = {
      address: addresss
    }
    this.props.dispatch(userActions.getAddressList(tempsData))

    if (temp && temp.walletName || temp && temp.walletName == null) {
      let tempWallet = temp && temp.walletName ? `/app/dashboard/${temp.walletName}/${temp.address}` : `/app/dashboard/Primary/${temp.address}`
      this.props.history.push(tempWallet)
    }
  }
  onSendCoin = () => {
    const { users } = this.props;
    let { getSavedAddress, } = users;

    const data = {
      from_address: getSavedAddress,
      to_address: this.state.toAddress,
      send_token_amount: this.state.amount,
    };

    console.log('datadatadatadata', data);
    this.props.dispatch(userActions.sendCoin(data))
  }

  send_wallet = () => {
    let gcn_balance = Number(this.state.amount1)
    let data = {
      "address": this.state.coinSelect,
      "amount": gcn_balance
    }
    this.props.dispatch(userActions.buyGCN(data))
  }

  contact_address = () => {
    const { cAddress } = this.state;
    const { users } = this.props;
    let { getAddressList } = users;

    let data = {
      "cAddress": cAddress,
      "address": this.props.match.params.address ? this.props.match.params.address : getAddressList && getAddressList[0] && getAddressList[0].address ? getAddressList[0].address : null
    }
    this.props.dispatch(userActions.addContractAddress(data))

  }

  handleCoinChange = (event) => {
    this.setState({ coinSelect: event.target.value });
  };

  copyTxIdToClipboard = (getSavedAddress) => {
    const tempInput = document.createElement('input');
    tempInput.value = getSavedAddress;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand('copy');
    document.body.removeChild(tempInput);
    this.setState({ copiedTxId: getSavedAddress });
    this.props.dispatch(alertActions.success("Copied!"));
  };


  render() {

    let { users } = this.props;
    let { getSavedAddress, getAddressList, getWalletListData, getUserWalletToBuy } = users;

    let walletAdd = this.props.match.params.address ? this.props.match.params.address : getAddressList && getAddressList[0] && getAddressList[0].address ? getAddressList[0].address : null

    console.log('getWalletListData', getUserWalletToBuy);

    return (

      <>



        <section className='overflow-hidden overflow-y-auto  lg:pb-0 pb-20'>
          <div className='w-11/12 mx-auto py-10'>
            <div className='border border-[#5B4DCA] rounded-[14px] p-6'>
              <h1 className='text-[26px] font-[700] text-[#FFFFFF] '>My wallet</h1>
              <div className='md:flex justify-between items-center'>
                <div className='  flex flex-none items-center md:space-x-4 space-x-4  justify-center py-6 px-3'>
                  <div onClick={() => this.handleOpenReceive()} className='flex cursor-pointer rounded-full all-btn-color px-8 py-3 space-x-2'>
                    <span className='flex justify-center items-center'><BsArrowDownCircle size={22} className='font-bold text-white' /></span>
                    <span className=" text-base font-bold flex justify-center items-center text-white "> Receive</span>
                  </div>
                  <div onClick={() => this.handleOpenNetwork(getWalletListData && getWalletListData[0])} className='flex cursor-pointer rounded-full all-btn-color px-8 py-3 space-x-2'>
                    <span className='flex justify-center items-center'><BsArrowUpCircle size={22} className='font-bold text-white' /></span>
                    <span className=" text-base font-bold flex justify-center items-center text-white "> Send</span>
                  </div>
                  {/* <div title='contact address' onClick={() => this.handleTransactionOpen()} className='flex justify-end items-center cursor-pointer'>
                    <MdOutlineAddCircleOutline className=' text-white font-bold' size={42} />
                  </div> */}
                </div>
                <div className='bg-[#5763D8] flex justify-between p-4 space-x-6 rounded-[12px]'>
                  <div>
                    <p className='xl:text-[22px] text-[14px] font-[700] text-[#FFFFFF]'>Available balance</p>
                    <p className='text-[14px] font-[400] text-[#FFFFFFB2]'>{getUserWalletToBuy && getUserWalletToBuy.gcnAmount ? getUserWalletToBuy.gcnAmount : '0.00'} LYA</p>
                  </div>
                  <div className='flex justify-end items-end pt-10'>
                    <img src="/img/wallet.png" alt="" className='w-8 h-8' />
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className='w-11/12 mx-auto py-10'>
            <div className='border border-[#5B4DCA] rounded-[14px] p-6'>
              <h1 className='text-[26px] font-[700] text-[#FFFFFF] border-b border-[#D9D9D975]'>Recent activity</h1>
              <>
                {
                  getWalletListData && getWalletListData.length > 0 ? getWalletListData.map((ele) => (
                    <div className='flex justify-between items-center border-b border-[#D9D9D975] cursor-pointer' onClick={() => this.handleOpenNetwork(ele)}>
                      <div className='flex flex-col space-y-1 py-4'>
                        {/* <p className='text-[#FFFFFFA6] text-[11px] font-[600]' >22-feb-2024</p> */}
                        <div className='flex items-center space-x-2'>
                          <div className='bg-[#4F91F5] text-white rounded-full w-14 h-14 flex justify-center items-center'>{ele && ele.symbol ? ele.symbol : null}</div>
                          <div>
                            <p className='text-[#FFFFFF] text-[16px] font-[600]'>{ele.name}</p>
                            <p className='text-[#FFFFFFA6] text-[11px] font-[400]' title={ele.address}>{ele && ele.address.substring(0, 20) ? ele.address.substring(0, 20) + "..." : ele.address}</p>
                          </div>
                        </div>
                      </div>
                      <div>
                        <p className='text-[16px] font-[600] text-[#ffffff]'>{ele.balance}</p>
                        {/* <p className='text-[11px] font-[400] text-[#FFFFFFA8] text-right'>$693</p> */}
                      </div>
                    </div>
                  ))
                    : null
                }
              </>

            </div>
          </div>
        </section>



        {/* <main className="relative z-0 flex-1 focus:outline-none">

          <div className=" bg-center bg-cover bg-no-repeat  lg:rounded-b-2xl rounded-b-full" style={{ backgroundImage: `url("/imglogo/Gradient-Head Background.png")` }}>
            <div className="py-20 space-y-4 xl:space-y-10 bg-gradient-to-t from-[#FFAF04]/60 to-[#FF5100]/80 lg:rounded-b-2xl rounded-b-full">
              <div className="flex justify-center items-center space-x-2 cursor-pointer ">
                <span className=" hover:text-white/60 text-base font-bold md:text-2xl text-white" onClick={() => this.handlePrimaryWalletOpen()}>{this.props.match.params.address ? this.props.match.params.walletName : "Primary"} Wallet
                </span>
                <span onClick={() => this.handlePrimaryWalletOpen()} className=' flex justify-center items-center'><MdOutlineKeyboardArrowDown size={36} className='font-bold text-white hover:text-white/60' /></span>
              </div>

              <div className="flex justify-center items-center space-x-2">
                <span className=" text-base font-bold md:text-2xl text-white">Available Balance
                </span>
                <span className='flex justify-center items-center text-base font-bold md:text-2xl text-white'>{getUserWalletToBuy && getUserWalletToBuy.gcnAmount ? getUserWalletToBuy.gcnAmount : '0.00'}</span>
              </div>
            </div>
          </div>
          <div className="px-6 py-2 md:py-6">


            <div className='md:flex flex-none items-center md:space-x-4 space-x-0 md:space-y-0 space-y-4 justify-center py-6 px-3'>
              <div onClick={() => this.handleOpenNetwork(getWalletListData && getWalletListData[0])} className='flex cursor-pointer rounded-full all-btn-color px-8 py-3 space-x-2'>
                <span className='flex justify-center items-center'><BsArrowUpCircle size={22} className='font-bold text-white' /></span>
                <span className=" text-base font-bold flex justify-center items-center text-white "> Send</span>
              </div>
              <div onClick={() => this.handleOpenReceive()} className='flex cursor-pointer rounded-full all-btn-color px-8 py-3 space-x-2'>
                <span className='flex justify-center items-center'><BsArrowUpCircle size={22} className='font-bold text-white' /></span>
                <span className=" text-base font-bold flex justify-center items-center text-white "> Receive</span>
              </div>
              <div onClick={() => this.handleOpenPayment()} className='flex cursor-pointer rounded-full all-btn-color px-8 py-3 space-x-2'>
                <span className='flex justify-center items-center'><BsArrowUpCircle size={22} className='font-bold text-white' /></span>
                <span className=" text-base font-bold flex justify-center items-center text-white "> Buy</span>
              </div>

            </div>
            <div className='flex justify-between items-center px-5'>

              <div className="flex items-center space-x-4 overflow-x-auto overflow-y-hidden sm:justify-start flex-nowrap text-white">
                <a onClick={() => this.handleTabChange(1)} className="flex items-center flex-shrink-0 px-5 py-2 border-b-4 dark:border-white dark:text-white cursor-pointer">Assets</a>
              </div>
              <div title='contact address' onClick={() => this.handleTransactionOpen()} className='flex justify-end items-center cursor-pointer'>
                <MdOutlineAddCircleOutline className=' text-white font-bold' size={42} /> </div>
            </div>

            {activeTab === 1 ?


              <>
                {
                  getWalletListData && getWalletListData.length > 0 ? getWalletListData.map((ele, index) => (
                    <div onClick={() => this.handleOpenNetwork(ele)} className='flex items-center justify-between px-5 w-full mt-10 cursor-pointer active:bg-gray-700 active:rounded-full active:p-2 '>
                      <div className='flex items-center justify-center'>
                        <div className=' flex items-center justify-center w-10 h-10 text-center md:w-16 md:h-16 bg-yellow-600 rounded-full text-black'>
                          <p className='text-xs md:text-base'>  {ele && ele.symbol ? ele.symbol : null}</p>
                        </div>
                        <div className="pl-4 text-base font-bold md:text-2xl text-white">{ele.name}
                          <br /> <span className='text-sm text-gray-200'>{ele.symble}</span>
                        </div>
                      </div>

                      <div className='text-white text-2xl font-bold flex justify-center items-center text-center'>{ele.balance}</div>
                    </div>
                  ))
                    : null
                }
              </>

              : null}

            {activeTab === 2 ?
              <section className='px-6 pt-4 pb-6 my-6  rounded-xl'>
                <div className='md:flex flex-none items-center md:space-x-4 space-x-0 md:space-y-0 space-y-4 justify-center py-4 px-3 bg-transparent lg:bg-slate-700 rounded-full'>
                  <div className='flex cursor-pointer rounded-full bg-black hover:bg-yellow-700 active:all-btn-color lg::px-12 px-6 text-center py-3 space-x-2'>
                    <span className=" text-base font-bold flex justify-center items-center text-white "> All</span>
                  </div>
                  <div className='flex cursor-pointer rounded-full bg-black hover:bg-yellow-700  active:all-btn-color lg::px-12 px-6 text-center py-3 space-x-2'>
                    <span className=" text-base font-bold flex justify-center items-center text-white "> In</span>
                  </div>
                  <div className='flex cursor-pointer rounded-full bg-black hover:bg-yellow-700  active:all-btn-color lg::px-12 px-6 text-center py-3 space-x-2'>
                    <span className=" text-base font-bold flex justify-center items-center text-white "> Out</span>
                  </div>

                </div>
              </section> : null
            }

            {
              this.state.fieldTicketId ?
                <>
                  <div className='flex justify-center items-center'>

                    <div className=" w-[350px] mx-auto md:w-[600px] fixed  z-[200px] top-40">

                      <div className="rounded bg-[#1B1C1D] md:overflow-hidden overflow-y-auto lg:h-full h-[400px]">
                        <div className='flex items-center justify-end'>
                          <button className="text-white inline-flex p-2 font-bold rounded-full hover:bg-orange-600" type="button">
                            <MdClose className='w-7 h-7' onClick={() => this.handlePrimaryWalletClose()} />
                          </button>
                        </div>

                        <h3 className='flex text-white items-center justify-center font-bold text-xl'>Select an account</h3>
                        <div className=" px-4 py-10 space-y-4 overflow-y-auto h-[400px]">
                          {
                            getAddressList && getAddressList.length > 0 ? getAddressList.map((ele, ind) => (
                              <div onClick={() => { this.Saveaddresss(ele) }} className="flex justify-start items-center w-[300px] md:w-[550px] p-2 rounded-xl  bg-white hover:bg-white/60 " >
                                <CiWallet className="w-8 h-8 text-slate-900 " /> <span className='px-4 text-center'>{ele.walletName ? ele.walletName : "Primary"} wallet</span>
                              </div>
                            )) : null
                          }

                          <div className='py-5'>
                            <button className="p-2 rounded-full text-yellow-500 flex justify-start items-center" onClick={() => { this.handleRes() }} >
                              <AiOutlinePlus className="w-7 h-7 text-yellow-500 text-xl font-bold" /> <span className='px-2  font-bold'>Add account</span>
                            </button>
                          </div>
                          {this.state.openText ?
                            <>
                              < div className="w-full ">
                                <input className={`w-[300px] md:w-[550px]   rounded-xl outline-none px-3 py-2.5`}
                                  placeholder="Enter Wallet Name" type="text"
                                  name="enter the name"
                                  value={this.state.addressName}
                                  onChange={(e) => { this.setState({ addressName: e.target.value }) }}
                                />
                              </div>

                              <div className='flex justify-center items-center py-2'>
                                <button onClick={() => this.onCreateWallet()} className="inline-flex py-2 px-10 rounded-xl all-btn-color hover:bg-orange-800"  >
                                  Create
                                </button>
                              </div>
                            </>
                            : null}
                        </div>


                        <div >

                        </div>
                      </div>
                    </div>
                  </div>
                </>
                :
                null
            }

            {
              this.state.transactionModal ?
                <>

                  <div className="w-[400px] md:w-[600px] fixed  z-40 top-10 md:top-16 2xl:top-28 left-2 md:left-[100px] lg:left-[400px] xl:left-[500px] 2xl:left-[800px]">

                    <div className="rounded bg-[#1B1C1D]">
                      <div className='flex items-center justify-end'>
                        <button className="text-white inline-flex p-2 font-bold rounded-full hover:bg-orange-600" type="button">
                          <MdClose className='w-7 h-7' onClick={() => this.handleTransactionClose()} />
                        </button>
                      </div>

                      <h3 className='flex text-white items-center justify-center font-bold text-xl'>Add Contract Address</h3>
                      <div className="space-y-4 px-4 py-10">


                        <div className='flex justify-between items-center border bg-transparent border-gray-400 text-gray-400 text-sm rounded-lg    w-full p-2.5  '>
                          <span>{getUserWalletToBuy}</span>
                          <button
                            onClick={() => this.copyTxIdToClipboard(getUserWalletToBuy)}
                            className="ml-2 text-center text-blue-500 cursor-pointer"
                            disabled={copiedTxId === getUserWalletToBuy}
                          >
                            {copiedTxId === getUserWalletToBuy ? <LuCopyCheck className='w-7 h-7 text-[#007F00]' /> : <GoCopy className='w-7 h-7' />}
                          </button>
                        </div>
                        <div>
                          <input className=" border bg-transparent border-gray-400 text-gray-400 text-sm rounded-lg   block w-full p-2.5    dark:text-white "
                            type="text" value={this.state.cAddress} onChange={(e) => { this.setState({ cAddress: e.target.value }) }}
                            name="Address" placeholder="Enter the contract Address">
                          </input>
                        </div>

                        <div className="flex justify-center items-center">
                          <button onClick={() => this.contact_address()} className=' cursor-pointer rounded-full all-btn-color px-12 py-3 space-x-2'>
                            <span className=" text-base font-bold flex justify-center items-center text-white "> Submit</span>
                          </button>
                        </div>

                      </div>

                    </div>
                  </div>
                </>
                : null
            }
          </div>
          <div className={this.state.isNetwork ? "w-[400px] md:w-[600px] fixed  z-40 top-10 md:top-16 left-2 md:left-[100px] lg:left-[400px] xl:left-[500px] 2xl:left-[800px]" : "hidden"} style={{ marginTop: '0rem', }
          }  >
            <div className=" rounded bg-[#1B1C1D]">
              <div className='bg-[#f77504] px-4 py-2 flex justify-between items-center text-white rounded-t'>
                <h1>Globel Citizen Identity Wallet</h1>
                <button onClick={() => this.handleCloseNetwork()}>
                  <ImCross className='text-gray-500' size={16} />
                </button>
              </div>
              <div className='bg-[#1B1C1D] px-2 py-4 justify-between items-center text-gray-200 rounded'>
                <div className=' flex items-center justify-center'>
                  <div className=' flex items-center justify-center w-10 h-10 text-center md:w-16 md:h-16 bg-yellow-600 rounded-full text-black'>
                    <img src='/assets/StakingPlan.png' alt='StakingPlan.png' className='w-10 h-10' />
                  </div>
                </div>
                <span className="font-bold text-2xl flex justify-center items-center py-2">0</span>

                <div className="space-y-4 p-4">
                  <div>
                    <label htmlFor="" className="py-0.5"> Receving Account</label>
                    <input className=" border bg-transparent border-gray-400 text-gray-400 text-sm rounded-lg   block w-full p-2.5    dark:text-white "
                      type="text"
                      value={this.state.toAddress}

                      name="Address" placeholder="Enter the receving account"
                      onChange={(e) => this.setState({ toAddress: e.target.value })} />
                  </div>
                  <div>
                    <label htmlFor="" className="py-0.5"> Amount</label>
                    <input className=" border bg-transparent border-gray-400 text-gray-400 text-sm rounded-lg   block w-full p-2.5    dark:text-white "
                      type="text"
                      value={this.state.amount}
                      name="Amount" placeholder="Enter the amount"
                      onChange={(e) => this.setState({ amount: e.target.value })}
                    >
                    </input>
                  </div>

                  <div onClick={() => this.onSendCoin()} className="flex justify-center items-center">
                    <button className=' cursor-pointer rounded-full all-btn-color px-12 py-3 space-x-2'>
                      <span className=" text-base font-bold flex justify-center items-center text-white "> Submit</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={this.state.isPayment ? "w-[400px] md:w-[600px] fixed  z-40 top-10 md:top-16 left-2 md:left-[100px] lg:left-[400px] xl:left-[500px] 2xl:left-[800px]" : "hidden"} style={{ marginTop: '0rem', }}  >
            <div className=" rounded bg-[#1B1C1D]">
              <div className='bg-[#E05D2D] px-4 py-2 flex justify-between items-center text-white rounded-t'>
                <h1>Payment</h1>
                <button onClick={() => this.handleClosePayment()}>
                  <ImCross className='text-gray-500' size={16} />
                </button>
              </div>
              <div className='bg-[#1B1C1D] px-2 py-4 justify-between items-center text-gray-200 rounded'>

                <div className='md:flex flex-none items-center md:space-x-4 space-x-0 md:space-y-0 space-y-4 justify-center py-4 px-3'>
                  <div
                    onClick={() => { this.handleResOut(1) }}
                    className='flex cursor-pointer rounded-full all-btn-color px-12 py-3 space-x-2'>
                    <span className=" text-base font-bold flex justify-center items-center text-white"> Crypto</span>
                  </div>
                  <div onClick={() => { this.handleResOut(2) }}
                    className='flex cursor-pointer rounded-full all-btn-color px-12 py-3 space-x-2'>
                    <span className=" text-base font-bold flex justify-center items-center text-white"> Banking</span>
                  </div>
                </div>

                {this.state.clickedOutside == 1 ?
                  <div className='bg-[#1B1C1D] px-2 py-4 justify-between items-center text-white rounded'>

                    <div className=' flex items-center justify-between text-xl p-4'>
                      <p>1 GCN</p>
                      <p>=</p>
                      <p>2 USDT</p>
                    </div>

                    <div className="space-y-4 p-4">
                      <div>
                        <label htmlFor="" className="py-0.5"> Select Coins</label>
                        <select
                          className="border bg-transparent border-gray-400 text-gray-400 text-sm rounded-lg block w-full p-2.5 dark:text-white"
                          id="Coins"
                          value={this.state.coinSelect}
                          onChange={this.handleCoinChange}
                          name="Coins"
                        >
                          <option value="">Select Item</option>
                          {getUserWalletToBuy &&
                            getUserWalletToBuy.usdtData &&
                            getUserWalletToBuy.usdtData.length > 0 ? (
                            getUserWalletToBuy.usdtData.map((ele, ind) => (
                              <option
                                key={ind}
                                value={ele && ele.address ? ele.address : ''}
                              >
                                {ele && ele.coinId && ele.coinId.name ? ele.coinId.name : ''}
                              </option>
                            ))
                          ) : (
                            <option value="" disabled>
                              No coins available
                            </option>
                          )}


                        </select>
                      </div>

                      <div>
                        <label htmlFor="" className="py-0.5"> Amount</label>
                        <input className=" border bg-transparent border-gray-400 text-gray-400 text-sm rounded-lg   block w-full p-2.5    dark:text-white "
                          type="text"
                          name="Amount"
                          placeholder="Enter the amount"
                          onChange={(e) => { this.setState({ amount1: e.target.value }) }}
                          value={this.state.amount1}
                        >
                        </input>
                      </div>

                      <div onClick={() => this.send_wallet()} className="flex justify-center items-center">
                        <button className=' cursor-pointer rounded-full all-btn-color px-12 py-3 space-x-2'>
                          <span className=" text-base font-bold flex justify-center items-center text-white "> Buy</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  : null}

                {this.state.clickedOutside == 2 ?
                  <div className='bg-[#1B1C1D] px-2 py-4 justify-between items-center text-gray-500 rounded'>
                    <div className=' flex items-center justify-between text-3xl p-4'>
                      <p>Comming Soon</p>
                    </div>
                  </div>
                  : null}
              </div>
            </div>
          </div>
        </main> */}

        <TetherModal
          handleOpenTether={this.state.isTether}
          handleCloseTether={this.handleCloseTether}
        />
        <ReceiveModal
          handleCloseReceive={this.handleCloseReceive}
          handleOpenPayment={this.state.isReceive}
          handleqrcode={getSavedAddress}
          walletAdd={walletAdd}
          props={this.props}
        />
      </>

    );
  }

}

function mapStateToProps(state) {
  const { users, dashboard } = state;
  const { overview } = users ? users : {};
  const { setting, user, wallet } = overview ? overview : {};
  return {
    users,
    setting,
    user,
    dashboard,
    wallet
  };
}
export default connect(mapStateToProps)(Dashboard);